export const exportacao = {
  explicacao:
    'O arquivo traz quem quer receber o brinde no Brasil, com o tamanho e o endereço de entrega, o total por tamanho, e em outra aba quem recebe a necessaire no exterior. Participantes excluídos não entram.',
  usoInterno: 'Incluir aba "Uso interno" com a matrícula',
  usoInternoHint: 'Não envie esta aba ao fornecedor.',
  baixar: 'Baixar',
  baixado: 'Arquivo gerado.',
  participantes: { botao: 'Exportar participantes' },
} as const;
